import { BookingWizardFlowTypes } from 'common/infrastructure/modules/appointment/interfaces/AppointmentTypes';
import { add, endOfMonth, startOfToday } from 'date-fns';
import { useMemo, useState } from 'react';

import { IGetFittingAvailabilityAdapter } from 'application/modules/bookingWizard/useCases/hooks/useCaseSelectFittingReservationDate';
import mboAPI from 'infrastructure/redux/adapters/mboAPI/mboApi';
import {
  selectExperienceType,
  selectLocation,
} from 'infrastructure/redux/slices/bookingWizard.selector';
import { useAppSelector } from 'infrastructure/redux/store/hooks';
const useGetFittingAvailability: IGetFittingAvailabilityAdapter = () => {
  const selectedLocationId = useAppSelector(selectLocation);
  const startDateTime = useMemo(() => startOfToday().toISOString(), []);
  const [endDateTime, setEndDateTime] = useState(
    endOfMonth(add(new Date(), { months: 1 })).toISOString(),
  );
  const experienceType = useAppSelector(selectExperienceType);

  const {
    data: availableDatesMap,
    error,
    isLoading,
    isFetching,
  } = mboAPI.useGetAvailableFittingDatesQuery(
    {
      locationId: selectedLocationId || '',
      startDateTime,
      endDateTime,
    },
    {
      skip:
        !selectedLocationId ||
        !startDateTime ||
        !endDateTime ||
        experienceType !== BookingWizardFlowTypes.ClubFitting,
    },
  );
  const availableDates = useMemo(
    () => availableDatesMap?.map((date) => new Date(date)),
    [availableDatesMap],
  );

  const handleFetchFurtherAvailableDates = (newDate: Date | null) => {
    if (newDate) {
      setEndDateTime(endOfMonth(add(newDate, { months: 1 })).toISOString());
    }
  };

  return {
    inProgress: isLoading || isFetching,
    error,
    result: availableDates,
    fetchFurtherAvailableDates: handleFetchFurtherAvailableDates,
  };
};

export default useGetFittingAvailability;
